import type { OpeningSessionDisplayStatus, OpeningSessionOrigin } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'
import { extractContentDispositionFilename } from '../tools/contentDisposition.tools'

export interface ExportOpeningSessionsParams {
  storeId?: number
  status?: OpeningSessionDisplayStatus
  origin?: OpeningSessionOrigin
  preAuthorizationsOnly?: boolean
  from?: string
  to?: string
}

export interface ExportOpeningSessionsResult {
  blob: Blob
  filename: string
}

const DEFAULT_FILENAME = 'pre-autorisations.xlsx'

export const exportOpeningSessions = async (
  params: ExportOpeningSessionsParams,
): Promise<ExportOpeningSessionsResult> => {
  const response = await gozokiApiWithAuth.get<Blob>('/opening-sessions/export', {
    params,
    responseType: 'blob',
  })
  return {
    blob: response.data,
    filename: extractContentDispositionFilename(
      response.headers['content-disposition'],
      DEFAULT_FILENAME,
    ),
  }
}
